import React from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';

export const withRouter = (Component) => {
  function Wrapper(props) {
    const params = useParams();
    const navigate = useNavigate();
    const location = useLocation();

    return (
      <Component
        params={params}
        navigate={navigate}
        location={location}
        {...props}
      />
    );
  }

  return Wrapper;
};
